import { render, staticRenderFns } from "./UpdateSundryItemOrderDetailsPopup.vue?vue&type=template&id=370bb274&scoped=true&"
import script from "./UpdateSundryItemOrderDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./UpdateSundryItemOrderDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSundryItemOrderDetailsPopup.vue?vue&type=style&index=0&id=370bb274&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370bb274",
  null
  
)

export default component.exports